<template>
  <div class="steps">
    <div
      v-bind:class="[stepArray.length==5?'width-4':'width-3']"
      v-for="(item,index) in stepArray"
      :key="index"
    >
      <div v-if="errorStep<=0" class="width-100" :style="index < currentVal ? lineFineTuning : ''">
        <div
          class
          v-bind:class="[index < currentVal && currentVal!== 6 ? 'color-pick circle' : 'color-no-pick circle-no-border', '']"
        ></div>
        <p
          v-show="index!=0"
          class="line-1"
          v-bind:class="[index<currentVal && currentVal !== 6 ? 'color-pick' : 'color-no-pick', '']"
        ></p>
        <p
          v-show="index!=stepArray.length-1"
          class="line-2"
          v-bind:class="[index<=currentVal-1 && currentVal !== 6 ? 'color-pick' : 'color-no-pick', '']"
        ></p>
      </div>
      <div v-else class="width-100">
        <div
          class
          v-bind:class="[index<errorStep ? 'color-pick circle' : index==errorStep?'color-pick circle-error' :'color-no-pick circle-no-border', '']"
        ></div>
        <p
          v-show="index!=0"
          class="line-1"
          v-bind:class="[index<errorStep ? 'color-pick' :index==errorStep?'color-error-pick-1' :'color-no-pick', '']"
        ></p>
        <p
          v-show="index!=stepArray.length-1"
          class="line-2"
          v-bind:class="[index<errorStep-1 ? 'color-pick' :index==errorStep-1?'color-error-pick-2' :'color-no-pick', '']"
        ></p>
      </div>
      <div class="width-100 mt-b">
        <p class="title" :class="[index < currentVal && currentVal!== 6 ?'activeText':'']">{{item}}</p>
      </div>
    </div>
  </div>
</template>
<style scoped lang="less">
.steps {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  width: 100%;
  /* overflow: scroll; */
  text-align: center;
  // padding: 40px 0px 14px 0px;
  box-sizing: border-box;
  padding-top: 7px;
}
.line-1 {
  width: 50%;
  height: 1px;
  position: absolute;
  z-index: 0;
  left: 0;
  top: 4.5px;
}
.line-2 {
  width: 50%;
  height: 1px;
  position: absolute;
  z-index: 0;
  top: 4.5px;
  left: 50%;
}
.mt-b {
  margin-bottom: 4px;
}
.color-pick {
  background: #fff;
}
.color-no-pick {
  background: #53c88d;
}
.color-error-pick-1 {
  background-image: linear-gradient(90deg, #b377f6 0%, #df3031 100%);
}
.color-error-pick-2 {
  background-image: linear-gradient(
    90deg,
    #007aff 0%,
    #8091ff 60%,
    #b377f6 100%
  );
}
.width-100 {
  width: 100%;
  position: relative;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  margin-top: 11px;
  -webkit-justify-content: center;
}
.title {
  width: 100px;
  line-height: 18px;
  font-size: 12px;
  color: #fff;
  opacity: 0.4;
  margin-top: 6px;
  font-weight: 400;
}
.activeText {
  opacity: 1 !important;
}
.width-2 {
  width: 50%;
}
.width-3 {
  width: 63px;
}
.width-4 {
  width: 74px;
}
.circle {
  width: 8px;
  height: 8px;
  /*border: 2px solid #fff;*/
  border-radius: 50%;
  /*background: #007AFF;*/
  z-index: 9;
}
.circle-error {
  width: 8px;
  height: 8px;
  /*border: 2px solid #fff;*/
  border-radius: 50%;
  background: #df3031;
  z-index: 9;
}
.circle-no-border {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  z-index: 9;
  background: #36b374;
  border: 1px solid #5ec28f;
}
// .circle-no-border::before {
//   display: inline-block;
//   content: "";
//   width: 10px;
//   height: 10px;
//   background: #fff;
//   opacity: 0.2;
//   position: absolute;
//   top: -2px;
//   z-index: 1;
//   left: 50%;
//   transform: translateX(-50%);
//   border-radius: 50%;
//   border: 2px solid #81a0c7;
// }
.circle::after {
  display: inline-block;
  content: "";
  width: 18px;
  height: 18px;
  /* background: rgba(0, 122, 255, 0.15); */
  // background: #fff;
  position: absolute;
  top: -4px;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  background-image: url("../../../../assets/refund/step-success.png");
  background-size: 100% 100%;
}
.circle-error::after {
  display: inline-block;
  content: "";
  width: 8px;
  height: 8px;
  background: rgba(223, 48, 49, 0.15);
  position: absolute;
  top: 0px;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
}
.mt-b[data-v-06feb85f] {
  margin-bottom: -40px;
  /* margin-top: 30px; */
}
.mt12 {
  margin-top: 12px;
}
</style>
<script>
    export default {
        data () {
            return {
                lineFineTuning: {
                    position: 'relative',
                    top: '-1px'
                }
            };
        },
        props: {
            currentVal: {
                type: Number,
                default: 2
            },
            errorStep: {
                type: Number,
                default: 0
            },
            stepArray: {
                type: Array,
                default: function () {
                    return ['步骤1', '步骤2', '步骤3', '步骤4', '步骤5'];
                }
            }
        },
        created () {
            console.log('currentVal', this.currentVal)
            console.log('errorStep', this.errorStep)
        }
    };
</script>
